import { Box, Grid, Typography } from "@mui/material";
import InputUpload from "../../components/InputUpload";
import RelationshipDialog from "../../components/RelationshipDialog";
import RelationshipList from "../../components/RelationshipList";
import StatusInput from "../../components/StatusInput";
import TranslationInputField from "../../components/TranslationInputField";
import ColourInput from "../../components/shared/ColourInput";
import Dropdown from "../../components/shared/Dropdown";
import AddRelationships from "../../components/shared/AddRelationships";
import FormInput from "../../components/shared/FormInput";
import VideoUpload from "../../components/VideoUpload";
import HorizontalCard from "../../components/HorizontalCard";

export const chooseInputComponent = (field, languageCode) => {
    const { handleInputChange, label, description, value, name, type, options, config } = field;

    let component = <></>;

    switch (type) {
        case 'm2o':
            const formattedValue = [{
                id: value,
                title: value || '',
                description: 'description',
            }];
            component = (
                <Box
                    sx={{
                        margin: '16px 0'
                    }}
                >
                    <Typography
                        className="form-label"
                        variant='label'
                    >
                        {label}
                    </Typography>
                    {
                        !!value &&
                        <Box sx={{ width: '100%', my: 2 }}>
                            <Grid container spacing={2}>
                                {
                                    formattedValue?.map(item => (
                                        <Grid key={item.id} item xs={12}>
                                            <HorizontalCard
                                                key={item.id}
                                                detailsUrl={config?.detailsUrl ? `${config?.detailsUrl}/${item.id}` : null}
                                                detailsPayload={config?.detailsPayload}
                                                detailsResponseHandler={config?.detailsResponseHandler}
                                                item={{
                                                    title: item?.title || '',
                                                    description: item?.description || '',
                                                    url: item.url || '',
                                                }}
                                                footerAction={null}
                                            />
                                        </Grid>
                                    ))
                                }
                            </Grid>
                        </Box>
                    }

                    {
                        !!!value &&
                        <Box sx={{ width: '100%', my: 2, background: '#f5f5f5', padding: '16px', borderRadius: '8px', border: '1px solid #e0e0e0' }}>
                            <Typography
                                sx={{
                                    fontSize: '1rem',
                                    color: '#757575',
                                    textAlign: 'center',
                                    fontStyle: 'italic',
                                }}
                            >Not linked to anything</Typography>
                        </Box>
                    }
                    <RelationshipDialog
                        title={config.title}
                        rows={config.rows}
                        headCells={config.headCells}
                        onSelect={handleInputChange}
                        url={config.url}
                        payload={config.payload}
                        searchOnly={config.searchOnly}
                        responseHandler={config.responseHandler}
                        buttonText={config.buttonText}
                    />
                </ Box>
            )
            break;
        case 'm2m':
            component = (
                <Box
                    sx={{
                        margin: '16px 0'
                    }}
                >
                    <Typography
                        className="form-label"
                        component='label'
                    >
                        {label}
                    </Typography>

                    <Typography
                        className="form-input-description"
                        component="p"
                    >
                        {description}
                    </Typography>

                    <RelationshipList
                        items={config.items}
                    />

                    <AddRelationships
                        field={name}
                        label={label}
                        description={description}
                        value={value}
                        onClose={handleInputChange}
                        selectedItems={config.items}
                        title={config.title}
                        url={config.url}
                        payload={config.payload}
                        columns={config.columns}
                        idField={config.idField}
                    />
                </ Box>
            )
            break;
        case 'image':
            component = (
                <InputUpload
                    field={name}
                    label={label}
                    description={description}
                    value={value}
                    handleInputChange={handleInputChange}
                    placeholder=""
                    variant="standard"
                    options={options}
                    config={config}
                    uploadHandler={(field, uploadedFileId) => { handleInputChange(uploadedFileId, field) }}
                />
            )
            break;
        case 'video':
            component = (
                <VideoUpload
                    key={value}
                    field={name}
                    label={label}
                    description={description}
                    value={value}
                    handleInputChange={handleInputChange}
                    placeholder=""
                    variant="standard"
                    options={options}
                    config={config}
                    baseUrl={process.env.REACT_APP_SHOTSTACK_ADMIN_API_URL}
                    uploadHandler={(field, uploadedFileId) => { handleInputChange(uploadedFileId, field) }}
                />
            )
            break;
        case 'font':
            component = (
                <Dropdown
                    inputProps={{
                        className: 'form-input'
                    }}
                    sx={{
                        color: '#262626 !important',
                        py: 0,
                        width: '100%'
                    }}
                    label={label}
                    field={name}
                    description={description}
                    value={value}
                    handleInputChange={handleInputChange}
                    placeholder=""
                    variant="standard"
                    options={options}
                />
            )
            break;
        case 'colour':
            component = (
                <ColourInput
                    inputProps={{
                        className: 'form-input'
                    }}
                    sx={{
                        color: '#262626 !important',
                        py: 0,
                        width: '100%'
                    }}
                    label={label}
                    field={name}
                    description={description}
                    value={value}
                    handleInputChange={handleInputChange}
                    placeholder=""
                    variant="standard"
                    type="color"
                />
            )
            break;
        case 'text':
            component = (
                <FormInput
                    inputProps={{
                        className: 'form-input'
                    }}
                    sx={{
                        color: '#262626 !important',
                        py: 0,
                        width: '100%'
                    }}
                    label={label}
                    field={name}
                    description={description}
                    value={languageCode ? (value[languageCode]?.[name] || '') : value}
                    handleInputChange={(field, name) => handleInputChange(field, name, languageCode)}
                    placeholder=""
                    variant="standard"
                />
            )
            break;
        case 'textarea':
            component = (
                <>
                    <FormInput
                        inputProps={{
                            className: 'form-input'
                        }}
                        sx={{
                            color: '#262626 !important',
                            py: 0,
                            width: '100%'
                        }}
                        label={label}
                        field={name}
                        description={description}
                        value={languageCode ? (value[languageCode]?.[name] || '') : value}
                        handleInputChange={(field, name) => handleInputChange(field, name, languageCode)}
                        placeholder=""
                        variant="standard"
                    />
                </>
            )
            break;
        case 'rich-text':
            component = (
                <>
                    <FormInput
                        inputProps={{
                            className: 'form-input'
                        }}
                        sx={{
                            color: '#262626 !important',
                            py: 0,
                            width: '100%'
                        }}
                        label={label}
                        field={name}
                        type={'rich-text'}
                        description={description}
                        value={languageCode ? (value[languageCode]?.[name] || '') : value}
                        handleInputChange={(field, name) => handleInputChange(field, name, languageCode)}
                        placeholder=""
                        variant="standard"
                    />
                </>
            )
            break;
        case 'status':
            component = (
                <StatusInput
                    name={name}
                    label={label}
                    description={description}
                    type={type}
                    config={config}
                    handleInputChange={handleInputChange}
                />
            )
            break;
        case 'translation':
            component = (
                <>
                    <TranslationInputField
                        name={name}
                        field={name}
                        label={label}
                        value={value}
                        description={description}
                        type={type}
                        config={config}
                        handleInputChange={handleInputChange}
                    />
                </>
            );

            break;
        default:
            component = (
                <></>
            );
    }

    return component;
}